import type {
  Image,
  ProductArticleDetails_ArticleFragment,
  ReferencesProductTable_ArticleFragment,
} from '@gql-generated/graphql'
import { atom } from 'jotai'

export const displayEcoTaxesDrawerAtom = atom(false)

export const displayBobDrawerAtom = atom(false)

export const displayProductPriceIncludedTaxDrawerAtom = atom(false)

export const productFiltersMobileItemOpen = atom<string | boolean | undefined>(undefined)

// Store all product articles (loaded by ReferencesProduct)
export const productArticlesAtom = atom<
  (ReferencesProductTable_ArticleFragment & ProductArticleDetails_ArticleFragment)[]
>([])

// Store selected reference when filter changes (null = use SSR product data)
export const selectedReferenceAtom = atom<string | null>(null)

export const isStickyVisibleAtom = atom<boolean>(true)

// Loading state for article switching
export const isArticleLoadingAtom = atom<boolean>(false)

export const productImagesByRefAtom = atom<Record<string, Image[]>>({})

export const showMonoDiscriminantInfoCardAtom = atom<boolean>(false)

export const productBuyBoxAddToCartAtom = atom<{
  quantity: number
}>({
  quantity: 1,
})

export const pageListAnalyticsAtom = atom<{
  title: string
}>({
  title: '',
})

// Prevent flickering back to skeletons if the tree remounts during streaming or enrichment.
export const isProductPageHydratedAtom = atom<boolean>(false)

export const displaySpecDrawerAtom = atom<boolean>(false)
